import { Button, styled } from "@mui/material";

export const GButton = styled(Button)(({ theme }) => ({
  padding: "1%",
}));
